module.exports = __webpack_public_path__ + "static/img/m_role.ad6dca3.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/mz/m_role.png
// module id = 0qeY
// module chunks = 7